import React from "react";
import { Kanban } from "lucide-react";
import { PmBackupPanel } from "./pm/PmBackupPanel";

export default function PmBackupSection() {
  return (
    <section className="swiss-card-flat p-6 mb-6" data-testid="pm-backup-section">
      <div className="flex items-center gap-2 mb-4">
        <Kanban size={14} />
        <div className="label">Lifecycle Board backup &amp; restore (admin only)</div>
      </div>
      <PmBackupPanel />
    </section>
  );
}
